import React, { useState } from "react";
import { connect } from "react-redux";
import { TabPanel, Item as TabItem } from "devextreme-react/tab-panel";
import { WMChargeType } from "../../../../const/constants";
import CustomerTransactions from "./CustomerTransactions";
import CustomerTransactionDetails from "./CustomerTransactionDetails";
import CustomerTransactionCharges from "./CustomerTransactionCharges";

// Generic "Open <TransactionType>" tab: non-committed transactions of the given
// transactionType (e.g. 'R' = Open Receipts, 'S' = Open Shipments) with three
// sub-tabs (Primary / Detail / Transaction Charges). Selecting a row in Primary
// drives the Detail and Transaction Charges sub-tabs.
const OpenTransactionsTab = (props) => {
    const { id, transactionType = "R", primaryGridKey, detailGridKey, chargesGridKey } = props;
    const [selectedTransactionId, setSelectedTransactionId] = useState(null);

    return (
        <TabPanel>
            <TabItem title="Primary">
                <CustomerTransactions
                    customerId={id}
                    transactionType={transactionType}
                    gridKey={primaryGridKey}
                    onTransactionSelected={setSelectedTransactionId}
                />
            </TabItem>
            <TabItem title="Detail">
                <CustomerTransactionDetails transactionId={selectedTransactionId} gridKey={detailGridKey} />
            </TabItem>
            <TabItem title="Transaction Charges">
                <CustomerTransactionCharges transactionId={selectedTransactionId} chargeType={WMChargeType.Transaction} gridKey={chargesGridKey} />
            </TabItem>
        </TabPanel>
    );
};

function mapStateToProps(state) {
    return {
        oidc: state.oidc,
    };
}
export default connect(mapStateToProps)(OpenTransactionsTab);
